import { DeliveryWindowsSettings } from "../../../../../configuration/delivery-windows-settings/models";

const iconsOfActionsList = [
  {
    icon: "trash",
    tooltip: "Eliminar",
  }
];

export const deliveryWindowsSettings = {
  searchText: 'Buscar ...',
  export: false,
  checkbox: true,
  disabled: false,
  dialogHability: true,
  filter: false,
  sort: false,
  paginator: true,
  iconsOfActions: iconsOfActionsList,
  hasDisabledCheckBoxItem: (row: DeliveryWindowsSettings, selection: DeliveryWindowsSettings[]) => {
    if (selection && selection.length > 0 && row && selection[0].id) {
      return selection.length === 1 && row.id === selection[0].id ? false : true;
    } else
      if (row.isGeneric) {
        return true;
      } else {
        return row.id ? false : true;
      }
  },
  columns: [
    {
      title: "Tipo de entidad",
      name: "entityType",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.entityType,
    },
    {
      title: "División",
      name: "divisionType",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.divisionType
    },
    {
      title: "Modalidad de despacho",
      name: "dispatchMode",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.dispatchMode,
    },
    {
      title: "Tipo de despacho",
      name: "dispatchType",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.dispatchType
    },
    {
      title: "Canal de venta",
      name: "saleChannel",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.saleChannel,
    },
    {
      title: "Hora de inicio",
      name: "startTime",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.startTime,
    },
    {
      title: "Hora de fin",
      name: "endTime",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.endTime,
    }
  ]
};
